export default __webpack_public_path__ + "static/media/DAIF_Data_Screen3_In-end.2c84a3bd.jpg";